import { PlayerPage } from './../player/player';
import { FindPage } from './../find/find';
import { PlaylistsPage } from './../playlists/playlists';
import { HomePage } from './../home/home';
import { TabsPage } from './../tabs/tabs';
import { Component } from '@angular/core';
import { NavController, App } from 'ionic-angular';
import { PlayerService } from '../../service/player.service';
import { ProfilePage } from '../profile/profile';
import { LoginPage } from '../login/login';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the MenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu',
  templateUrl: 'menu.html',
})
export class MenuPage {

  public content;
  public tabPage = TabsPage;
  public homePage = HomePage;

  constructor(public navCtrl: NavController,
    public playerService: PlayerService,
    public appCtrl: App,
    private storage: Storage ) {
  }

  ngOnInit() {

  //  this.playerService.load(1, false);

  }

  ShowPlayer() {
    this.navCtrl.push(PlayerPage);
  }


  openFind(cat)
  {
    this.appCtrl.getActiveNav().setRoot(FindPage, {cat: cat});
  }

  openHome()
  {
    this.appCtrl.getActiveNav().setRoot(HomePage);
  }

  openPlaylists()
  {
    this.appCtrl.getActiveNav().setRoot(PlaylistsPage);
  }

  openProfile()
  {
    this.appCtrl.getActiveNav().setRoot(ProfilePage);
  }

  logga_ut()
  {
      this.storage.set("login", "#");
      this.navCtrl.setRoot(LoginPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts